module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reports-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-manager-track-report",
      "md-label": "Путевой отчет менеджера",
      "to": {
        name: 'ManagerTrackReport'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-realisation-errors-report",
      "md-label": "Ошибки в реализациях",
      "to": {
        name: 'RealisationErrorsReport'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-missing-documents-report",
      "md-label": "Отсутствующие документы",
      "to": {
        name: 'MissingDocumentsReport'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-payment-report",
      "md-label": "Оплата",
      "to": {
        name: 'PaymentReport'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-dispatcher-report",
      "md-label": "Диспетчер",
      "to": {
        name: 'DispatcherReport'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793e4ccd","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/reports-menu.vue
// module id = 1201
// module chunks = 0